import type { ReactElement } from "react";

import dayjs from "dayjs";

import { shortMonthDayAndYear } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";
import { TruncatedTextWithTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import {
    StyledListCaption,
    StyledListItemContainer,
    StyledListItemMainBlock,
    StyledListItemMainData,
    StyledListItemWrapper,
    StyledListLastUpdatedDate,
    StyledListMetadata,
    StyledListName,
    StyledListValue,
    StyledMetadataBlock,
} from "./styles";

type ListItemProps = {
    name: string;
    icon: ReactElement;
    lastUpdated?: Date;
    websitesCount: number;
    onClick: () => void;
    tag?: ReactElement | null;
    metadataElements?: ReactElement[];
};

const ListItem = ({ name, lastUpdated, websitesCount, tag, icon, metadataElements, onClick }: ListItemProps) => {
    return (
        <StyledListItemContainer>
            <StyledListItemWrapper onClick={onClick}>
                <StyledListItemMainBlock>
                    {icon}
                    <StyledListItemMainData>
                        <StyledListName>
                            <TruncatedTextWithTooltip
                                fontVariant="subsectionTitle"
                                color={colorsPalettes.carbon[400]}
                            >
                                {name}
                            </TruncatedTextWithTooltip>
                            {tag}
                        </StyledListName>
                        {lastUpdated ? (
                            <I18n
                                translatable={{
                                    key: "si.my-list.list-item.last-updated",
                                    replacements: {
                                        date: dayjs(lastUpdated).format(shortMonthDayAndYear),
                                    },
                                }}
                                element={StyledListLastUpdatedDate}
                            />
                        ) : null}
                    </StyledListItemMainData>
                </StyledListItemMainBlock>
                <StyledMetadataBlock>
                    <StyledListMetadata>
                        <StyledListValue>{websitesCount}</StyledListValue>
                        <StyledListCaption>{translate("si.common.companies")}</StyledListCaption>
                    </StyledListMetadata>
                </StyledMetadataBlock>
            </StyledListItemWrapper>
            {metadataElements && metadataElements.length > 0 ? (
                <StyledMetadataBlock>
                    {metadataElements.map((metaElement: ReactElement, i: number) => {
                        return (
                            <StyledListMetadata
                                className={i === metadataElements.length - 1 ? "noBorder" : ""}
                                key={`meta-element-${i}`}
                            >
                                {metaElement}
                            </StyledListMetadata>
                        );
                    })}
                </StyledMetadataBlock>
            ) : null}
        </StyledListItemContainer>
    );
};

export default ListItem;
